<div>
    <textarea #editor></textarea>
    <ng-select #ngSelect *ngIf="showSelect" [items]="fieldNames" bindLabel="name" bindValue="name" (change)="onSelectField($event)" placeholder="Select a field">
    </ng-select>
  </div>
  